document.addEventListener("DOMContentLoaded", function () {
    const popup = document.querySelector(".meta-size_popup");
    const sizeChartButton = document.querySelector(".size-chart");
    const overlay = document.querySelector(".global-overlay");
    const closeButton = popup?.querySelector(".close");

    if (!popup) return;
    sizeChartButton?.addEventListener("click", function () {
        popup.classList.add("active");
        overlay?.classList.add("active");
    });
    function closePopup() {
        popup.classList.remove("active");
        overlay?.classList.remove("active");
    }
    closeButton?.addEventListener("click", function () {
        closePopup();
    });
    overlay?.addEventListener("click", function () {
        closePopup();
    });
    document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
            closePopup();
        }
    });
    const tabs = popup.querySelectorAll(".pf-tabs .tabs li");
    const tabItems = popup.querySelectorAll(".pf-tabs .tab-item");
    tabs.forEach(function (tab) {
        tab.addEventListener("click", function () {
            const targetId = tab.dataset.tab;
            if (!targetId) return;
            tabs.forEach(function (item) {
                item.classList.remove("active");
                item.setAttribute("aria-selected", "false");
            });
            tabItems.forEach(function (item) {
                item.classList.remove("active");
            });
            tab.classList.add("active");
            tab.setAttribute("aria-selected", "true");
            const targetContent = popup.querySelector("#" + targetId);
            if (targetContent) {
                targetContent.classList.add("active");
            }
        });
    });
});